import { Col, Row } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import InvestorContext from "../../../context/investor/context";
import { getUserStatus } from "../../../models/user/enum";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import { getInvestorType } from "../../../models/investor/enum";
import { ICity } from "../../../models/city/response";
import EndPoints from "../../../services/end-points";
import AppContext from "../../../context/app/context";
import { IStore } from "../../../models/store/response";
import { useLocation } from "react-router-dom";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { createActiveStoreFilter } from "../../../utils/helpers/store-filters";

interface IProps { }

const InvestorFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(InvestorContext);

  const [city, setCity] = useState<ICity[]>([]);
  const [loadingCity, setLoadingCity] = useState(true);
  const [store, setStore] = useState<IStore[]>([]);
  const [loadingStore, setLoadingStore] = useState(true);

  const { direction } = useContext(AppContext);
  const location = useLocation();
  const [initialValues, setInitialValues] = useState<Record<string, any>>({});

  useEffect(() => {
    const filters = getFiltersFromURL();

    const initialValuesObj = {};
    filters.forEach((f) => {
      initialValuesObj[f.name] = f.value;
    });

    setInitialValues(initialValuesObj);
  }, [location.search]); useEffect(() => {
    const getCity = async () => {
      try {
        const { data } = await EndPoints.city.getAllCities({
          light: true,
          perPage: -1,
        });
        setCity(data.data);
        setLoadingCity(false);
      } catch (error) {
      } finally {
        setLoadingCity(false);
      }
    };
    getCity();
  }, [direction]);

  useEffect(() => {
    const getStore = async () => {
      try {
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
          filters: [createActiveStoreFilter()],
        });
        setStore(data.data);
        setLoadingStore(false);
      } catch (error) {
      } finally {
        setLoadingStore(false);
      }
    };
    getStore();
  }, [direction]);

  return (
    <Form
      formId="investor-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.statusInvestor
              ? {
                name: "statusInvestor",
                value: data.statusInvestor,
                operation: "eq",
              }
              : undefined,
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
            data?.type
              ? {
                name: "type",
                value: data.type,
                operation: "eq",
              }
              : undefined,
            data?.cityId
              ? {
                name: "cityId",
                value: data.cityId,
                operation: "eq",
              }
              : undefined,
            data?.nameStore
              ? {
                name: "nameStore",
                value: data.nameStore,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="statusInvestor"
            label={`${t("current_status")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2].map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2].map((status, index) => {
                return {
                  label: t(getUserStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
          <FieldBuilder
            name="type"
            label={`${t("type")}`}
            width="large"
            input={{
              type: "select",
              options: [1, 2]?.map((investor, index) => {
                return {
                  label: t(getInvestorType(investor)),
                  value: investor as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8}>
          <FieldBuilder
            name="cityId"
            label={`${t("city")}`}
            width="large"
            input={{
              type: "select",
              loading: loadingCity,
              options: city.map((city, index) => {
                return {
                  type: "select",
                  label: city?.name as string,
                  value: city?.id as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={8} xxl={8}>
          <FieldBuilder
            name="nameStore"
            label={`${t("store")}`}
            width="large"
            input={{
              type: "select",
              loading: loadingStore,
              allowSearch: true,
              options: store.map((st, index) => {
                return {
                  type: "select",
                  label: st?.name as string,
                  value: st?.name as string,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default InvestorFilter;
